import { useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { TranscricaoListaItem } from '../../../../../../interfaces/entities/Transcricao/TranscricaoListaItem';
import {
  buildResolverPendenciaPath,
  resolveTranscricaoResourceToken,
} from '../../../../../../interfaces/entities/Transcricao/transcricaoResourceToken';
import { useTranscricaoCarregamento } from '../../../hooks/useTranscricaoCarregamento';
import { mergeDetalheComListaItem } from '../../../utils/transcricaoListaUtils';
import { mapHistoricoSumarioToTimeline } from '../../../utils/transcricaoHistoricoUtils';

type DetalheTab = 'historico' | 'dados';

type DetalheLocationState = {
  listaItem?: TranscricaoListaItem;
};

export const useDetalhesTranscricaoPage = () => {
  const { idTranscricao: idParam } = useParams<{ idTranscricao: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const listaItem = (location.state as DetalheLocationState | null)?.listaItem;
  const idTranscricao = resolveTranscricaoResourceToken(idParam);

  const [abaAtiva, setAbaAtiva] = useState<DetalheTab>('historico');
  const [termosModalAberto, setTermosModalAberto] = useState(false);

  const {
    loading,
    erro,
    detalhe,
    historicoStatus,
    historicoSumario,
    erroHistoricoSumario,
  } = useTranscricaoCarregamento(idTranscricao);

  const detalheMesclado = useMemo(
    () => (detalhe ? mergeDetalheComListaItem(detalhe, listaItem) : null),
    [detalhe, listaItem],
  );

  const codStatusCliente =
    historicoStatus?.codStatusTranscricao ?? detalheMesclado?.codStatusTranscricao ?? null;

  const timelineSteps = useMemo(
    () => mapHistoricoSumarioToTimeline(historicoSumario),
    [historicoSumario],
  );

  const handleResolverPendencia = () => {
    if (!idTranscricao) return;
    navigate(buildResolverPendenciaPath(idTranscricao));
  };

  return {
    idTranscricao,
    loading,
    erro,
    detalhe: detalheMesclado,
    codStatusCliente,
    abaAtiva,
    setAbaAtiva,
    termosModalAberto,
    setTermosModalAberto,
    timelineSteps,
    erroHistoricoSumario,
    handleResolverPendencia,
    voltarPath: '/guiasEautorizacoes/transcricaoSolicitacao/consultar',
  };
};
